export function tabbedSection() {
  let activeClass = 'active';

  $('body').on('click', '.tabbed-head a', function (e) {
    e.preventDefault();

    let current = $(this);

    if (!current.hasClass('activeClass')) {
      let index = current.index();

      current
        .addClass(activeClass).siblings().removeClass(activeClass);

      current
        .closest('.container')
        .find('.tabbed-item:eq(' + index + ')')
        .addClass(activeClass)
        .siblings().removeClass(activeClass);
    }


  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabbed-section.js